<template>
    <ul class="list-group" v-if="answer">
        <li class="list-group-item" v-for="(question, index) in questions" :key="index">
            <div class="d-flex justify-content-start">
                <span class="text-muted mr-2" :class="classByVotes(answer[index], partyAnswer[index])">{{ index + 1}}.</span>
                <div class="flex-fill">
                    <div>{{ question.title }}</div>
                    <div class="mt-1 text-muted" style="font-size:85%">„{{ question.text }}“</div>
                    <div class="mt-2" style="font-size:85%">
                        <div class="d-flex">
                            <div class="mr-2">
                                <span>Deine Position</span>:<br />
                                <span>Position der Partei</span>:
                            </div>
                            <div>
                                <mat-vote-icon :value="answer[index]"></mat-vote-icon>
                                <br />
                                <mat-vote-icon :value="partyAnswer[index]"></mat-vote-icon>
                            </div>
                        </div>
                        <div class="mt-2 text-muted" v-if="partyReason && partyReason[index]"><strong>Begründung der Partei</strong>: „{{ partyReason[index] }}“</div>
                    </div>
                </div>
                <div v-show="weight[index]">
                    <font-awesome-icon class="text-primary" icon="star" />
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import MatVoteIcon from './MatVoteIcon';
import questions from '../data/questions';

export default {
    name: "MatAnswers",
    components: {
        MatVoteIcon
    },
    props: {
        answer: Array,
        weight: Array,
        partyAnswer: Array,
        partyReason: Array
    },
    data() {
        return {
            questions
        }
    },
    methods: {
        classByVotes(a, b) {
            switch (Math.abs(a - b)) {
                case 0:
                    return '';

                case 1:
                    return 'text-secondary';

                case 2:
                    return 'text-danger';
            }
        }
    }
}
</script>

<style scoped>

</style>